"use client";

import { useEffect, useState, type RefObject } from "react";

export interface UseIntersectionOptions {
  root?: Element | null;
  rootMargin?: string;
  threshold?: number | number[];
}

export function useIntersection(
  ref: RefObject<Element | null>,
  options: UseIntersectionOptions = {},
  initialValue = false
): boolean {
  const { root = null, rootMargin = "0px", threshold = 0 } = options;
  const [isIntersecting, setIsIntersecting] = useState(initialValue);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      },
      { root, rootMargin, threshold }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, root, rootMargin, threshold]);

  return isIntersecting;
}
